.UnitManagementSection {
  flex: 1;
  display: flex;
}
.UnitManagementSection .Unit {
  padding: 0.2em;
  font-size: 1.5em;
}
.UnitManagementSection .Unit .Details {
  display: flex;
}
.UnitManagementSection .Unit .Details .Status {
  width: 1em;
}
.UnitManagementSection .Unit .Details .Status .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
}
.UnitManagementSection .Unit .Details .Status .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.UnitManagementSection .Unit .Details .Status .Thumbnail .UnitHealthBar .Label {
  display: none;
}
.UnitManagementSection .Unit .Details .Status .Name {
  font-size: 0.25em;
  text-align: center;
}
.UnitManagementSection .Unit .Details .Inventory .ItemGrid {
  font-size: 0.5em;
  position: relative;
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas: "a c e" "b d f";
  gap: 0.05em;
  padding: 0.1em;
  border-width: 0.05em;
  border-style: dashed;
  border-radius: 0.2em;
  border-color: #051F29;
  background-color: #f0ead6;
}
.UnitManagementSection .Unit .Details .Inventory .ItemGrid .Item {
  width: 1em;
  height: 1em;
  padding: 0.05em;
  box-sizing: content-box;
  border-color: #051F29;
}
.UnitManagementSection .Unit .Details .Inventory .ItemGrid .Item[isDefault] .DiceFace {
  box-shadow: none;
  border-color: transparent;
  background-color: transparent;
  border-radius: 0em;
}
.UnitManagementSection .Unit .Details .Passives {
  text-align: center;
}
.UnitManagementSection .Unit .Details .Passives .Text {
  font-size: 0.15em;
  color: #f0ead6;
}
.UnitManagementSection[direction=vertical] {
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.UnitManagementSection[direction=vertical] .Unit {
  align-items: center;
  justify-content: center;
}
.UnitManagementSection[direction=vertical] .Unit .Details {
  align-items: center;
  flex-direction: column;
}
.UnitManagementSection[direction=vertical] .Unit .Details .Inventory {
  margin-top: 0.2em;
}
.UnitManagementSection[direction=vertical] .Unit .Details .Passives {
  margin-top: 0.2em;
  width: 1.5em;
}
.UnitManagementSection[direction=horizontal] {
  flex-direction: column;
}
.UnitManagementSection[direction=horizontal] .Unit {
  flex: 1;
  display: flex;
  align-items: center;
}
.UnitManagementSection[direction=horizontal] .Unit .Details {
  align-items: flex-end;
}
.UnitManagementSection[direction=horizontal] .Unit .Details .Inventory {
  margin-left: 0.2em;
}
.UnitManagementSection[direction=horizontal] .Unit .Details .Passives {
  margin-left: 0.2em;
  height: 1.3em;
  width: 1.5em;
  display: flex;
  align-items: center;
}
